import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AmToasterService } from '@angularminds/am-toaster';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RestService } from 'src/app/services/rest.service';
import { map, distinctUntilChanged, tap, switchMap, catchError, delay } from 'rxjs/operators';
import { of, concat, Observable, Subject } from 'rxjs';
import { IUser } from 'src/app/services/interfaces/user';
import { GeneralService } from 'src/app/services/general.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-wallet-access',
  templateUrl: './wallet-access.component.html',
  styleUrls: ['./wallet-access.component.css']
})
export class WalletAccessComponent implements OnInit {

  accessWalletForm: FormGroup;
  access: any[] = [];
  isButtonDisabled: boolean = false;
  isSubmitted: boolean;

  users$: Observable<IUser[]>;
  userLoading = false;
  userInput$ = new Subject<string>();
  defaultAccess: any[] = [];
  walletId: any;
  createdBy;
  currentUserId
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private amToasterService: AmToasterService,
    private bsModalRef: BsModalRef,
    private generalService: GeneralService,

  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.accessWalletForm = this.fb.group({
      access: ['', [Validators.required]],
    });
    this.getAllUsersList()
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.accessWalletForm.controls;
  }
  defaultUser;
  userOrg: any[];
  orgIndex;

  getAllUsersList() {
    console.log("User List...");
    this.userLoading = true
    this.restService.fetch("/api/users/self/search").subscribe(userResp => {
      this.users$ = userResp
      this.access = this.defaultAccess;
      this.users$.forEach((use: any) => {
        if (use._id == this.currentUserId) {
          console.log('use:==>> ', use);
          if (!this.createdBy) {
            this.access.push(use._id)
          } else {
            let index = _.findIndex(this.access, (access) => {
              return access + "" !== this.createdBy + ""
            })
            if (index !== -1) {
              this.access.push(this.createdBy)
            }
            this.access.push(use._id)
          }
          use.disabled = true
        }
      })

      // this.accessWalletForm.patchValue({
      //   access: this.access
      // })
      console.log('this.accessWalletForm: ', this.accessWalletForm.value);
      console.log('this.access:==>> ', this.access);
      this.userLoading = false;
    }, error => {
      this.userLoading = false;
    })
  }

  loadUsers() {
    this.users$ = concat(
      of([]), // default items
      this.userInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.userLoading = true)),
        switchMap(term =>
          this.generalService.searchUsers(term, this.defaultUser).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.userLoading = false)),
          ),
        ),
      ),
    );
  }
  addAccess() {
    let condition;
    if (!this.createdBy) {
      condition = {
        $set: {
          access: this.access,
          // createdBy: this.currentUserId
        }
      }
    } else {
      condition = {
        $set: {
          access: this.access
        }
      }
    }

    this.isButtonDisabled = true
    this.restService.put(`/api/wallets/updateFields`, condition).subscribe(res => {

      this.amToasterService.show("success", res.message || "Wallet updated successfully", "Success")
      this.isButtonDisabled = false;
      this.bsModalRef.hide();
    }, err => {
      this.isButtonDisabled = false;
      this.amToasterService.show("error", err && err.message || err || "Error in Updating wallet access", "Error")
    })

  }

  // /api/users/organization //getting All users List
  cancel(): void {
    this.bsModalRef.hide();
  }

  trackByFn(item: any) {
    return item._id;
  }

  clear(item){
    console.log('item: ', item);
  }
}
